import { SessionType, useSessionStore } from '@/hooks/useSessionStore';
import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { toast } from 'sonner';
import { postAudioGenerateV2 } from '@/service/generatorv2';
import { GeneratorResponseDTO } from '@/service/generator';
import useGeneratorStore from '@/state/generator-store';
import JenErrorToast from '@/components/ui/jen-error-toast';

const LocalStoragePromptQueryKey = 'PromptQueryKey';

const updateSessionCredit = (session: SessionType, creditBalance: number) => {
  return {
    ...session,
    user: {
      ...session.user,
      credit: {
        ...session.user.credit,
        value: creditBalance,
      },
    },
  };
};

export const GenerateWithQuery = () => {
  const { session, setSession } = useSessionStore();
  const { setGeneratorResult } = useGeneratorStore();
  const [searchParams] = useSearchParams();
  const prompt = searchParams.get('prompt') || '';

  const generateTrack = async (prompt: string) => {
    try {
      const { data } = await postAudioGenerateV2({
        prompt: prompt,
        duration: 60,
        fadeOutLength: 0,
        assist: true,
        format: 'mp3',
        length: 60,
        model: '1.6c',
        folderId: undefined,
        trackName: '',
        tracksNum: 1,
      });
      if (!data) return;
      const result = data[0];
      const creditBalance = result.creditBalance || 0;
      setSession(updateSessionCredit(session, creditBalance));
      const generatorResponse = { ...result } as GeneratorResponseDTO;
      setGeneratorResult(generatorResponse);
    } catch (error: any) {
      toast(<JenErrorToast error={error} />, {
        className: '!border-0 !shadow-none',
        unstyled: true,
      });
    }
  };

  useEffect(() => {
    (async () => {
      if (!session.isLoaded) return;
      if (prompt) {
        // login status
        if (session.user.id) {
          await generateTrack(prompt);
          // not login
        } else {
          console.log('save prompt and go to login');
          localStorage.setItem(LocalStoragePromptQueryKey, prompt);
        }
      } else {
        const localStoragePrompt = localStorage.getItem(LocalStoragePromptQueryKey);
        if (localStoragePrompt) {
          await generateTrack(localStoragePrompt);
          localStorage.removeItem(LocalStoragePromptQueryKey);
        }
      }
    })();
  }, [session.isLoaded]);

  return <></>;
};
